/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updatePaymentAccountReference} from '../api'

export const useMutationUpdatePaymentAccountReference = createReactQueryMutationHook('updatePaymentAccountReference', updatePaymentAccountReference)
